import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-faq-button',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css'],
})
export class FaqButtonComponent {
  constructor(private readonly router: Router) {}

  navigate() {
    const url = this.router.serializeUrl(this.router.createUrlTree(['/faq']));
    window.open(url, 'faqWindow');
  }
}
